import React, { useCallback } from 'react';

import { ClassName, I18nText } from '../../../../../types';
import { IconsEnum } from '../../../../../assets/icons/types';

import { TooltipPlacement } from '../../../../../helpers/tooltips/tooltipsConstants';

import { SelectedMaterialUUID } from '../../../selectedMaterialsTypes';

import {
  DownloadSelectedMaterialQueryResponse,
  DOWNLOAD_SELECTED_MATERIAL_QUERY
} from '../../../queries/downloadSelectedMaterial.query';

import { useShowToastOnErrorChange } from '../../../../../common/hooks/useShowToastOnErrorChange';

import { useDownloadNanoId } from '../../../../downloads/hooks/useDownloadNanoId';

import { useDownloadSelectedMaterial } from '../../../hooks/useDownloadSelectedMaterial';

import { PureTooltipIconButtonHelper } from '../../../../../helpers/buttons/PureTooltipIconButtonHelper';

import { DownloadCache } from '../../../../downloads/DownloadCache';

interface DownloadSelectedMaterialButtonProps {
  selectedMaterialUuid: SelectedMaterialUUID;
  className?: ClassName;
  iconClassName?: ClassName;
  icon?: IconsEnum;
  i18nText?: I18nText;
  tooltipI18nText?: I18nText;
  tooltipPlacement?: TooltipPlacement;
  tooltipSingleton?: boolean;
}

function DownloadSelectedMaterialButton({
  selectedMaterialUuid,
  className,
  iconClassName,
  icon,
  i18nText,
  tooltipI18nText,
  tooltipPlacement,
  tooltipSingleton
}: DownloadSelectedMaterialButtonProps) {
  const {
    downloadSelectedMaterial,
    downloadSelectedMaterialLoading,
    downloadSelectedMaterialErrorMessage
  } = useDownloadSelectedMaterial<DownloadSelectedMaterialQueryResponse>({
    query: DOWNLOAD_SELECTED_MATERIAL_QUERY,
    cacheKeys: [DownloadCache.indexCacheKey()]
  });

  useShowToastOnErrorChange({ error: downloadSelectedMaterialErrorMessage });

  const { downloadNanoId } = useDownloadNanoId();

  const handleClick = useCallback(() => {
    downloadSelectedMaterial({
      uuid: selectedMaterialUuid,
      deviceNanoId: downloadNanoId
    });
  }, [selectedMaterialUuid, downloadNanoId, downloadSelectedMaterial]);

  return (
    <PureTooltipIconButtonHelper
      dataGa="selected-material-download-button"
      className={className}
      icon={icon}
      iconClassName={iconClassName}
      i18nText={i18nText}
      tooltipI18nText={tooltipI18nText}
      tooltipPlacement={tooltipPlacement}
      tooltipSingleton={tooltipSingleton}
      disabled={downloadSelectedMaterialLoading}
      onClick={handleClick}
    />
  );
}

export default DownloadSelectedMaterialButton;
